import type { SessionAttendance } from "@/lib/api/attendance";
import type { RollMark } from "@/components/attendance/roll-recovery";

/** Missing marks stay unrecorded; a small absent group is named without truncation. */
export function sessionRollSummary(roster: SessionAttendance["roster"], draft?: Record<string, RollMark>, missingWord = "unrecorded") {
  const rows = roster.map(row => ({ name: row.preferred_name ?? row.legal_name, status: draft ? draft[row.student_id]?.status : row.status }));
  const parts: string[] = [];
  for (const [status, label] of [["present", "present"], ["late", "late"], ["absent", "absent"], ["excused", "excused"]] as const) {
    const people = rows.filter(row => row.status === status);
    if (!people.length) continue;
    parts.push(`${people.length} ${label}${status === "absent" && people.length <= 3 ? `: ${people.map(row => row.name).join(", ")}` : ""}`);
  }
  const unmarked = rows.filter(row => !row.status).length;
  if (unmarked) parts.push(`${unmarked} ${missingWord}`);
  return parts.join(" · ") || "No learners enrolled";
}
